import { IconWrapper } from '../runtime';
export default IconWrapper('refresh', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M13 12.1534C11.8077 13.5871 10.0104 14.4998 8 14.4998C4.41015 14.4998 1.5 11.5896 1.5 7.99979C1.5 4.40994 4.41015 1.49979 8 1.49979C10.5197 1.49979 12.7046 2.93355 13.7833 5.02975L13.875 5.24979M14.35 1.24979V5.24979H10.35",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});